import Icon, { IconProps } from './Icon';

import RollBack from '../../../assets/icons/rollback.svg?react';

const Rollback: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <RollBack />
        </Icon>
    );
};

export default Rollback;
